const getDefaultState = () => {
	return {
		survey_table: null,
		survey_detail: null,
		survey_form: {
			photo: null,
			completed_at: null,
		},
	}
}

const default_state = getDefaultState()

export { default_state }